import React from "react";

type Props = {
  testId?: string;
  caption?: string;
  label: string;
  min: number;
  max: number;
  step: number;
  value: number;
  setValue: (value: number) => void;
};

export const PromptSliderField: React.FC<Props> = ({
  testId,
  caption,
  label,
  min,
  max,
  step,
  value,
  setValue,
}) => {
  return (
    <form className="txu-form-field">
      <label
        data-balloon={caption}
        data-balloon-pos="up-left"
        data-balloon-length="xlarge"
      >
        {label}
      </label>
      <p>Value: {value || "OpenRouter default"}</p>
      <input
        className="txu-input tw-w-full"
        data-testid={testId}
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => setValue(Number(e.target.value))}
      />
    </form>
  );
};
